

(function() {
    var getLocationData = function(location) {
        var origin = location.origin,
            data;

        location = location.location || location;

        if (location.isModel) {
            data = location.getData();
        }
        else {
            data = location;
        }

        if (origin === 'clicked') {
            data = Object.assign({clicked: true}, data);
        }

        return data;
    };

    Object.assign(Ext.util.Format, {
        badgedAttributeRenderer(attribute) {
            return SA.BadgedAttributeLabel.getHtml({attribute});
        },

        commaList(items, conjunction, singularNoun) {
            var pluralNoun = Ext.util.Inflector.pluralize(singularNoun),
                moreThanTwoTpl;

            if (items.length === 1) {
                return items[0] + ' ' + singularNoun;
            }
            else if (items.length === 2) {
                return items.join(' ' + conjunction + ' ') + ' ' + pluralNoun;
            }
            else {
                moreThanTwoTpl = new Ext.XTemplate('{initialItems}, {conjunction} {lastItem} {pluralNoun}');

                return moreThanTwoTpl.apply({
                    conjunction,
                    initialItems: items.slice(0, -1).join(', '),
                    lastItem: items[items.length - 1],
                    pluralNoun
                });
            }
        },

        formatValue(value, format) {
            return SA.formatValue(value, format);
        },

        locationRenderer(location) {
            if (!location) {
                return location;
            }

            location = getLocationData(location);

            var encode = Ext.util.Format.htmlEncode,
                alias = location.locationAlias,
                name = encode(location.name);

            if (alias) {
                return [
                    '<span>',
                        '<span class="sa-locations-list-alias">', encode(alias), '</span>',
                        ' \u00A0',
                        '<span class="sa-locations-list-alias-name">[', name, ']</span>',
                    '</span>'
                ].join('');
            }

            return name;
        },

        singularize(value) {
            return Ext.util.Inflector.singularize(value);
        }
    });
})();

Ext.getDoc().on('keydown', function(ev) {
    if (ev.getKey() === ev.BACKSPACE) {
        var target = ev.getTarget();

        if (target) {
            switch (target.tagName.toUpperCase()) {
                case 'TEXTAREA':
                    return;
                case 'INPUT':
                    switch (target.getAttribute('type')) {
                        case null:
                        case 'text':
                        case 'password':
                        case 'file':
                        case 'email':
                        case 'number':
                        case 'search':
                        case 'date':
                            return;
                    }
            }
        }

        ev.preventDefault();
    }
});

(function() {
    var types = Ext.data.Types,
        number = types.NUMBER;

    types.PROPORTION = Ext.applyIf({
        type: 'proportion',

        convert(value) {
            return Ext.Number.constrain(number.convert(value), 0, 1);
        }
    }, number);
})();

Ext.ClassManager.setAlias('Ext.tip.Tip', 'widget.tip');

delete Ext.tip.Tip.prototype.minWidth;

Ext.define('SA.XTemplateCompiler', {
    override: 'Ext.XTemplateCompiler',

    parseTag: function(tag) {
        var me = this,
            ret = me.callParent([tag]);

        if (me.validTypes) {
            me.validTypes = false;
            me.definitions.pop();

            ret = ret.replace(/validTypes.*values : ""/, 'values == null ? "" : values');
        }

        return ret;
    }
});

Ext.define('SA.MultiSlider', {
    override: 'Ext.slider.Multi',

    onClickChange: function() {
        this.callParent(arguments);

        this.fireEvent('trackclick');
    }
});

Ext.define('SA.tip.ToolTip', {
    override: 'Ext.tip.ToolTip',

    onMouseMove: function(e) {
        var me = this,
            t = me.delegate ? e.getTarget(me.delegate) : me.triggerElement = true,
            xy;

        if (t) {
            me.targetXY = e.getXY();
            if (t === me.triggerElement) {
                if (!me.hidden && me.trackMouse) {
                    xy = me.getTargetXY();
                    if (me.constrainPosition) {
                        xy = me.el.adjustForConstraints(xy, me.el.parent());
                    }
                    me.setPagePosition(xy);
                }
            } else {
                me.hide();
                me.lastActive = new Date(0);
                me.onTargetOver(e);
            }
        } else if ((!me.closable && me.isVisible()) && me.autoHide !== false) {
        }
    }
});

Ext.define('SA.util.Observable', {
    override: 'Ext.util.Observable',

    statics: {
        captureArgs: function(o, fn, scope) {
            o.fireEventArgs = Ext.Function.createInterceptor(o.fireEventArgs, fn, scope, false);
        }
    }
});

Ext.define('SA.AbstractComponent', {
    override: 'Ext.AbstractComponent',

    beforeSetPosition: function () {
        var me = this,
            constrain = me.constrain,
            constrainHeader = me.constrainHeader,
            pos;

        me.constrain = false;
        me.constrainHeader = false;

        pos = me.callParent(arguments);

        me.constrain = constrain;
        me.constrainHeader = constrainHeader;

        return pos;
    },

    setEnabled(enabled) {
        return this.setDisabled(!enabled);
    }
});

Ext.define('SA.Component', {
    override: 'Ext.Component',

    shadow: false,

    focusTask: new Ext.util.DelayedTask(Ext.Component.prototype.focus),

    destroy: function() {
        var me = this,
            floatParent = me.floatParent;

        me.callParent();

        if (floatParent && me.isDestroyed && floatParent.floatingItems) {
            floatParent.floatingItems.remove(me);
        }
    },

    makeFloating() {
        this.callParent(arguments);

        this.mun(this.el, {keydown: this.onKeyDown, scope: this});
        this.mon(this.el, {keydown: this.onKeyDownPatched, scope: this});
    },

    onKeyDownPatched(e) {
        if (!SA.view.ExtFloatingKeyDownHandlingToggle.isEnabled()) {
            return;
        }

        var me = this,
            shift,
            focusables,
            first,
            last;

        if (e.getKey() == Ext.EventObject.TAB) {
            shift = e.shiftKey;
            focusables = me.el.query(':focusable');
            first = focusables[0];
            last = focusables[focusables.length - 1];
            if (first && last && e.target === (shift ? first : last)) {
                e.stopEvent();

                (shift ? last : first).focus();
            }
        }
    }
});



Ext.define('SA.AbstractComponent', {
    override: 'Ext.AbstractComponent',

    statics: {
        flushLayouts: function() {
            var context = this.pendingLayouts;

            if (context && context.invalidQueue.length && Ext.globalEvents.hasListeners.beforelayout) {
                Ext.globalEvents.fireEvent('beforelayout');
            }

            this.callParent();
        }
    }
});

Ext.define('SA.container.AbstractContainer', {
    override: 'Ext.container.AbstractContainer',

    add: function() {
        var me = this,
            args = Ext.Array.slice(arguments),
            index = (typeof args[0] == 'number') ? args.shift() : -1,
            layout = me.getLayout(),
            addingArray, items, i, length, item, pos, ret, doUpdateLayout;

        if (args.length == 1 && Array.isArray(args[0])) {
            items = args[0];
            addingArray = true;
        } else {
            items = args;
        }

        ret = items = me.prepareItems(items, true);
        length = items.length;

        if (me.rendered) {
            Ext.suspendLayouts(); 
        }

        if (!addingArray && length == 1) { 
            ret = items[0];
        }

        for (i = 0; i < length; i++) {
            item = items[i];
            if (!item) {
                Ext.Error.raise("Cannot add null item to Container with itemId/id: " + me.getItemId());
            }

            pos = (index < 0) ? me.items.length : (index + i);

            if (item.floating) {
                if (item.autoShow) {
                    doUpdateLayout = true;
                }

                me.floatingItems = me.floatingItems || new Ext.util.MixedCollection();
                me.floatingItems.add(item);
                item.onAdded(me, pos);
            } else if ((!me.hasListeners.beforeadd || me.fireEvent('beforeadd', me, item, pos) !== false) && me.onBeforeAdd(item) !== false) {
                doUpdateLayout = true;
                me.items.insert(pos, item);
                item.onAdded(me, pos);
                me.onAdd(item, pos);
                layout.onAdd(item, pos);

                if (me.hasListeners.add) {
                    me.fireEvent('add', me, item, pos);
                }
            }
        }

        if (doUpdateLayout) {
            me.updateLayout();
        }

        if (me.rendered) {
            Ext.resumeLayouts(true);
        }

        return ret;
    }
});

Ext.define('SA.view.AbstractView', {
    override: 'Ext.view.AbstractView',

    onBindStore: function(store, initial, propName) {
        if (!initial && propName === 'store') {
            this.bindStore(store, false, 'dataSource');
        }
        else {
            this.setMaskBind(store);
        }
    }
});

Ext.define('SA.LoadMask', {
    override: 'Ext.LoadMask',

    onShow() {
        this.callParent(arguments);

        this.msgEl.setStyle('display', 'none'); 
    },

    render() {
        this.callParent(arguments);

        this.addCls('x-mask-msg-with-sa-message-spinner');

        Ext.widget({xtype: 'message-spinner', text: this.msg, renderTo: this.el.dom});
    },

    setZIndex: function(index) {
        var me = this,
            owner = me.activeOwner;

        if (owner) {
            index = (parseInt(owner.el.getStyle('zIndex'), 10) || 0) + 1;
        }

        me.getMaskEl().setStyle('zIndex', index - 1);

        return me.mixins.floating.setZIndex.apply(me, arguments);
    }
});

Ext.define('SA.ZIndexManager', {
    override: 'Ext.ZIndexManager',

    show: function() {
        var tempHidden = this.tempHidden;

        if (tempHidden) {
            Ext.Array.removeBy(tempHidden, function(cmp) {
                return cmp.isDestroyed;
            });
        }

        this.callParent();
    }
});

Ext.define('SA.data.Field', {
    override: 'Ext.data.Field',

    constructor: function(config) {
        if (Ext.isNumber(config)) {
            config = config + '';
        }

        this.callParent([config]);
    }
});

Ext.define('SA.menu.CheckItem', {
    override: 'Ext.menu.CheckItem',

    showCheckbox: false,

    initComponent: function() {
        this.callParent();

        this.setIconCls(this.group ? 'sa-menu-item-radio' : 'sa-menu-item-checkbox');
    }
});

Ext.define('SA.menu.Item', {
    override: 'Ext.menu.Item',

    hideOnClick: null,

    initComponent: function() {
        var me = this;

        if (me.hideOnClick == null) {
            me.hideOnClick = !me.menu;
        }

        me.callParent();
    },

    afterRender: function() {
        var me = this,
            iconHtml;

        me.callParent();

        iconHtml = me.iconHtml;

        me.iconHtml = '';

        if (iconHtml) {
            me.setIconHtml(iconHtml);
        }

        if (me.arrowEl) {
            me.arrowEl.setStyle('display', 'none');
        }
    },

    beforeRender: function() {
        this.callParent();

        this.renderData.hasIcon = this.iconCls || this.iconHtml;
    },

    deactivate: function() {
        var me = this;

        if (me.activated) {
            me.el.removeCls(me.activeCls);
            me.hideMenu();
            me.activated = false;
            me.fireEvent('deactivate', me);
        }
    },

    focus: function(sel, delay, callback, scope) {
        this.callParent([sel, true, callback, scope]);
    },

    onClick: function() {
        var me = this,
            menu = me.menu,
            parentMenu = me.parentMenu;

        me.callParent(arguments);

        if (menu && menu.isVisible()) {
            menu.toFront();
        }
        else if (parentMenu && parentMenu.isVisible() && parentMenu.floating) {
            parentMenu.toFront();
        }
    },

    setIconHtml: function(html) {
        html = (html == null ? '' : html) + '';

        if (html !== this.iconHtml) {
            var iconEl = this.iconEl;

            if (iconEl) {
                iconEl.update(html);
            }

            this.iconHtml = html;
        }
    },

    setMenu: function() {
        this.callParent(arguments);

        if (this.menu) {
            this.setIconCls('sa-menu-item-arrow');
            this.setIconHtml('<svg><use href="#sa-icon-right-chevron"></use></svg>');
        }
    }
});

Ext.define('SA.menu.Menu', {
    override: 'Ext.menu.Menu',

    layout: {type: 'vbox', align: 'stretchmax'},
    overflowY: 'auto',

    toFrontOnShow: false,

    initComponent: function() {
        this.callParent();

        if (this.track) {
            SA.view.menu.MenuVisibilityTracker.track(this);
        }
    },

    beforeDestroy() {
        if (this.isVisible()) {
            this.hide();
        }

        this.callParent();
    },

    focus: function(sel, delay, callback, scope) {
        this.callParent([sel, true, callback, scope]);
    },

    onMouseLeave: function(ev) {
        var me = this,
            activeItem = me.activeItem,
            menu = activeItem && activeItem.menu,
            menuEl = menu && menu.getEl();

        if (Ext.isChrome && menuEl && menuEl.contains(ev.getRelatedTarget())) {
            return;
        }

        me.callParent([ev]);
    },

    wasRecentlyVisible: function() {
        return SA.view.menu.MenuVisibilityTracker.wasRecentlyVisible(this);
    }
});

Ext.define('SA.dom.Element', {
    override: 'Ext.dom.Element',

    getWidth: function (contentWidth, preciseWidth) {
        var me = this,
        dom = me.dom,
        hidden = me.isStyle('display', 'none'),
        rect, width, floating;

        if (hidden) {
            return 0;
        }

        if (Ext.supports.BoundingClientRect) {
            rect = dom.getBoundingClientRect();
            width = (me.vertical && !Ext.isIE9 && !Ext.supports.RotatedBoundingClientRect) ?
                (rect.bottom - rect.top) : (rect.right - rect.left);
            width = preciseWidth ? width : Math.ceil(width);
        } else {
            width = dom.offsetWidth;
        }

        if (Ext.supports.Direct2DBug && !me.vertical) {
            floating = me.adjustDirect2DDimension('width');
            if (preciseWidth) {
                width += floating;
            }
            else if (floating > 0 && floating < 0.5) {
                width++;
            }
        }

        if (contentWidth) {
            width -= me.getBorderWidth("lr") + me.getPadding("lr");
        }

        return (width < 0) ? 0 : width;
    },

    mask(text) {
        var maskEl = this.callParent(arguments);

        if (!text) {
            return;
        }

        maskEl.addCls('x-mask-with-sa-message-spinner');

        this.$cache.data.maskMsg.hide();

        Ext.widget({xtype: 'message-spinner', text, renderTo: maskEl.dom});
    }
});

Ext.define('SA.data.Connection', {
    override: 'Ext.data.Connection',

    onStateChange: function() {
        if (SA.Env.isTestServer) {
            try {
                this.callParent(arguments);
            }
            catch (ex) {
                var msg = 'onStateChange error\n' + (ex.stack || '');

                msg = msg.replace(/Ext\.define\./g, '').replace(/http:[\w\/\.]*\//g, '');

                if (Ext.isWebKit) {
                    msg = msg.replace(/ at /g, ' ')
                        .replace(/ext\.js[\d:]+/g, '')
                        .replace(/\(\)/g, '')
                        .replace(/ +/g, ' ')
                        .slice(0, 240);
                }

                throw new Error(msg);
            }
        }
        else {
            this.callParent(arguments);
        }
    }
});




Ext.define('SA.data.Store', {
    override: 'Ext.data.Store',

    removeBy: function(fn, scope) {
        var toRemove = [];

        this.each(record => {
            if (fn.call(scope || this, record)) {
                toRemove.push(record);
            }
        });

        if (toRemove.length) {
            this.remove(toRemove);
        }
    }
});

Ext.Array.removeBy = function(array, fn, scope) {
    for (var index = array.length - 1 ; index >= 0 ; --index) {
        if (fn.call(scope || array, array[index])) {
            Ext.Array.erase(array, index, 1);
        }
    }

    return array;
};

Ext.dom.Element.prototype.ifCls = Ext.Component.prototype.ifCls = function(condition, cls) {
    this[condition? 'addCls' : 'removeCls'](cls);
};

Ext.define('SA.xss.menu.Item', {
    override: 'Ext.menu.Item',

    encodeText: true,

    beforeRender: function() {
        this.callParent();

        if (this.encodeText) {
            var renderData = this.renderData;

            renderData.text = Ext.util.Format.htmlEncode(renderData.text);
        }
    },

    setText: function(text) {
        this.callParent([Ext.util.Format.htmlEncode(text)]);
        this.text = text;
    }
});

(function() {
    Object.assign(d3.selection.prototype, {
        up() {
            return this.select((d, i, a) => a[i].parentNode);
        }
    });
})();